import { Typography } from "@mui/material";

/**
 * Structural rather than `CondensedShipment`: the unauthenticated submit-quote
 * command-link landing publishes a strict allowlist and renders this too, and
 * the id and type are all this component reads.
 */
interface ShipmentIdLikeShipment {
  info: {
    id: number;
    type: ShipmentType;
  };
}

interface Props {
  shipment: ShipmentIdLikeShipment;
}

export function ShipmentIDText(props: Props) {
  const { shipment } = props;
  if (!shipment?.info.id) {
    return null;
  }
  const shipmentId = shipment.info.id;
  const isProject = shipment?.info?.type === "MULTI_SHIPMENT_PROJECT";
  const shipmentType = isProject ? "Project ID" : "Shipment ID";

  return (
    <Typography>
      {shipmentType}: <b>{shipmentId}</b>
    </Typography>
  );
}
